import create, { SetState } from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject } from '@constants/empty';

type RewardEventsStoreType = {
  selectedGoal: boolean;
  setSelectedGoal: (goal: any) => void;
};

export const rewardEventsStore = create<RewardEventsStoreType>(
  (set: SetState<RewardEventsStoreType>) => ({
    selectedGoal: emptyObject,
    setSelectedGoal: (goal) =>
      set((state) => ({
        ...state,
        selectedGoal: { ...goal }
      }))
  })
);

const useRewardEventStore = createHook(rewardEventsStore);

export default useRewardEventStore;
